<!--  https://xd.adobe.com/view/043c2377-c87d-41bf-b429-2ffe2322e7ce-516f/specs/ 
https://docs.google.com/presentation/d/1UivJFMHQGhHTr5JY2Nq057cU3yz4bjN19aF1Y7TOsnw/edit#slide=id.g13fb061f812_3_1
https://docs.google.com/presentation/d/13UsZSW6pwkxbykyikLyZZ6SMvyENk4zDX6HOSUztTt4/edit#
https://xd.adobe.com/view/466aea0b-ec57-4d10-9fd8-060219a9c9bb-1339/screen/4464d8f8-fdc6-4685-be3f-58ed46ffbe76
https://xd.adobe.com/view/a57761db-68d1-4812-acd9-e595217ba478-f024/screen/b2a87e78-9a19-4c53-a677-498ce65ec1a6/
https://xd.adobe.com/view/2374a01a-d36a-4e45-97c5-badb24d25dbf-7627/
https://xd.adobe.com/view/d5a107af-b8fd-4c74-b1b4-458954ebd791-80f2/screen/16a13403-5112-4528-8740-b387f91310d5/specs/
-->
<template>
	<div id="payproff" class="clearfix darkblue notosans">
    <div v-if="dashdata && dashdata !== 'undefined'" id="checkpayproffbanner" class="md-col-7 xs-col-12 lg-col-7 sm-col-7 flex justify-center highlights items-center hide mx-auto white-background not-rounded m0 p0">
        <span class=""><i class="el-icon-circle-check green h3 m0"></i></span>
        <p class="darkblue h6 p1 m0 center mr3 my1">Success! Entreprisekontrakten er nu underskrevet!</p>
        <p class="m0 p0 pointer" @click="closebanner()"><i class="el-icon-close darkblue"></i></p>
      </div>
      <div v-if="loading">
        <Loading></Loading>
      </div>
      <div class="clearfix col-11 noto-sans darkblue" v-else>
            <div class="col-12 px0" >
                    <div class="col-12 px0 flex flex-column">
                      <div class="flex justify-start items-center mt3" v-if="!dashdata">
                        <p class="h4 semi-bold line-height-2 my2 darkblue">
                          Bankverifikation
                        </p>
                      </div>  
                      <div v-if="!haspayproff && isexist">
                          <div class="clearfix white-background  my2">
                            <p class="h4 darkblue py1 m0 semi-bold">Dit IBAN-nummer sikrer, at dine betalinger behandles hurtigt og korrekt.</p>
                            <div class="flex flex-column col-12 p2 m0 items-start " >
                              <div class="block" >
                                <p class="h5 xs-m0 m0 px2">Sådan finder du din IBAN:</p>
                                <ul>
                                  <li>Log ind på din netbank.</li>
                                  <li>Gå til kontodetaljer eller kontooversigt.</li>
                                  <li>Find og noter dit IBAN-nummer. Det starter typisk med 'DK' for danske bankkonti.</li>
                                </ul>
                                <div class="m0 lg-col-6 md-col-6 xs-col-12 sm-col-12 px2" >
                                  <label class="p0 m0 font12" for="partneribannew"><span class="red">*</span>Iban-nummer</label>
                                  <el-input v-model="partneriban" required id="partneribannew" class=" white-background" maxlength="22"  placeholder="DKXXXXXXXXXXXXXXXXXX" clearable></el-input>
                                  <label class="error red h5 small" v-if="ibanmessage">{{ibanmessage}}</label>
                                </div>
                              </div>
                              <button @click="updateStatusiban(partneriban),updateStatus('clicked')" :disabled="!verifylink" class="mx2 mt3 lg-col-3 xxl-col-3 md-col-3 sm-col-3 xs-col-5 action-button white no-borde flex justify-center items-center rounded">
                                <span class="mx2 my1">Godkend med MitID</span>
                              </button>
                            </div>
                            <!-- <p class="" v-if="!verifylink">Det ser ud til, at du allerede har udfyldt formularen for at tilmelde dig Payproff. Tjek venligst din e-mail for bekræftelseslinket for at fortsætte, eller kontakt os for yderligere hjælp</p> -->
                          </div>
                      </div>
                      <!-- <p class="h5 regular darkblue line-height-golden mb3" v-if="!haspayproff && !isexist">
                        Du kan registrere din konto her
                      </p>
                      <p class="h5 regular darkblue line-height-golden mt3" v-else-if="(haspayproff || isexist) && !dashdata">
                        Du kan opdatere din iban her
                      </p> -->
                      <div v-if="haspayproff">
                          <p class="h5 ml4 m0"><i class="el-icon-success green mr1 h4"></i>Verificeret</p>
                        </div>
                    </div>
            </div>
            <div class="py1"></div>
            <div>
              <div v-if="!dashdata && !isexist">
                <div class="h3 semi-bold" v-if="dashdata">Verificer</div>
                <el-form id="cvrfrom" :model="payprofform" class="md-col-7 px0 lg-col-7 sm-col-7 xs-col-12 py2" :rules="anbefalformrules" ref="payproffform" label-position="top">
                  <form-wizard ref="createPayproffFormWiz" shape="tab" color="#ffffff">
                    <tab-content v-if="dashdata">
                      <div class="clearfix">
                        <div class="mb2 flex flex-column items-start p0">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="152.26" height="35.735" viewBox="0 0 152.26 35.735">
                            <defs>
                              <clipPath id="clip-path">
                                <rect id="Rectangle_1428" data-name="Rectangle 1428" width="152.26" height="35.735" fill="#2265fc"/>
                              </clipPath>
                            </defs>
                            <g id="Payproff_logo" clip-path="url(#clip-path)">
                              <path id="Path_4272" data-name="Path 4272" d="M820.931,52.36v0Z" transform="translate(-668.671 -41.591)" fill="#2265fc"/>
                              <path id="Path_4273" data-name="Path 4273" d="M820.931,78.36v0Z" transform="translate(-668.671 -62.769)" fill="#2265fc"/>
                              <path id="Path_4274" data-name="Path 4274" d="M3.494,27.738a3.853,3.853,0,0,1,.3-.372q2.463-2.4,4.931-4.8c.271-.264.549-.523.8-.808a.759.759,0,0,1,.633-.259q3.152.009,6.305.01c1.97,0,3.941.024,5.912-.007A9.011,9.011,0,0,0,28.8,18.744,8.648,8.648,0,0,0,31.36,13.45a9.011,9.011,0,0,0-5.207-9.257,9.5,9.5,0,0,0-4.171-.9q-10.8.015-21.607,0C.254,3.3.132,3.281,0,3.272V.022C.073.017.14.007.207.007c7.5,0,14.992-.016,22.487,0a11.9,11.9,0,0,1,6.235,1.822,12.161,12.161,0,0,1,5.7,7.677,11.819,11.819,0,0,1-1.288,9.005,12.351,12.351,0,0,1-5.591,5.1,13.307,13.307,0,0,1-5.745,1.244q-5.332.014-10.664,0a.509.509,0,0,0-.4.17C9.7,26.257,8.445,27.47,7.2,28.69c-.979.956-1.952,1.917-2.929,2.874Q2.3,33.493.323,35.42L0,35.735V10.221H26.076l.036.047L25.357,11q-2.207,2.135-4.413,4.272-1.355,1.317-2.692,2.65a.686.686,0,0,1-.529.22c-1.429-.008-2.859,0-4.288,0a.6.6,0,0,1-.094-.028l4.634-4.548H3.428v14.1l.067.072" transform="translate(0 0)" fill="#2265fc"/>
                              <path id="Path_4275" data-name="Path 4275" d="M472.8,65.616v-2.6c.058,0,.125-.009.192-.009q2.828,0,5.656.008a3.2,3.2,0,0,0,1.457-.308,1.853,1.853,0,0,0,1.124-1.607,11.79,11.79,0,0,0-.017-1.9A2.135,2.135,0,0,0,479,57.22c-2.04,0-4.08,0-6.12,0q-.116,0-.232.006a.9.9,0,0,0-.936,1q0,5.32,0,10.64c0,.062-.008.124,0,.185.012.14-.047.19-.188.189q-1.205-.007-2.411,0c-.136,0-.178-.057-.173-.181,0-.085,0-.17,0-.255q0-5.077,0-10.153a4.575,4.575,0,0,1,.334-1.856,3.527,3.527,0,0,1,2.549-2.057,4.586,4.586,0,0,1,1.053-.135q3.06-.019,6.12,0a4.823,4.823,0,0,1,4.967,4.65,15.076,15.076,0,0,1-.083,2.473,4.341,4.341,0,0,1-2.755,3.434,5.416,5.416,0,0,1-2.2.474c-1.955.007-3.91,0-5.865,0-.075,0-.15-.01-.248-.016" transform="translate(-381.958 -44.465)" fill="#2265fc"/>
                              <path id="Path_4276" data-name="Path 4276" d="M224.51,65.464c0-.844,0-1.654.006-2.464,0-.046.082-.122.134-.13a3.038,3.038,0,0,1,.439-.017q2.688,0,5.377,0a3.091,3.091,0,0,0,1.369-.287,1.816,1.816,0,0,0,1.1-1.449,6.616,6.616,0,0,0-.041-2.326,2.088,2.088,0,0,0-2.2-1.727q-3.036,0-6.073,0a1.92,1.92,0,0,0-.549.058.85.85,0,0,0-.64.794c-.022.3-.008.6-.008.9q0,4.995.014,9.989c0,.215-.06.275-.275.272-.742-.013-1.483-.009-2.225,0-.182,0-.235-.049-.235-.236.012-3.523.045-7.046.012-10.568a3.649,3.649,0,0,1,3.223-3.8,5.437,5.437,0,0,1,.9-.073c2.024,0,4.049-.022,6.072.035a4.77,4.77,0,0,1,4.768,4.515,9.31,9.31,0,0,1-.115,2.905,4.434,4.434,0,0,1-2.624,3.1,5.364,5.364,0,0,1-2.285.513c-1.924.009-3.847.008-5.771.009-.114,0-.228-.013-.369-.021" transform="translate(-179.766 -44.315)" fill="#2265fc"/>
                              <path id="Path_4277" data-name="Path 4277" d="M312.791,73.965c.966,0,1.933-.039,2.9.009a3.634,3.634,0,0,1,3.192,1.9,3.87,3.87,0,0,1,.447,1.9c.01,1.058.03,2.118-.009,3.175a6.291,6.291,0,0,1-.254,1.592,3.38,3.38,0,0,1-3.3,2.439c-1.845.043-3.7.079-5.537-.042a3.645,3.645,0,0,1-.944-7.043,3.37,3.37,0,0,1,1.085-.206c1.661-.025,3.322-.016,4.983-.024.181,0,.235.06.232.243-.011.7-.009,1.391,0,2.086,0,.166-.032.219-.219.218q-2.387-.014-4.775,0a1.06,1.06,0,0,0-1.1,1.115,1.091,1.091,0,0,0,1.048,1.143c.363-.009.726.01,1.089.011q1.947.006,3.894.007a1.08,1.08,0,0,0,1.219-1.211q0-1.773,0-3.547c0-.856-.379-1.26-1.238-1.264-1.87-.009-3.74,0-5.61.006-.314,0-.316,0-.318-.3,0-.68,0-1.36-.01-2.04,0-.12.029-.173.149-.174s.232-.009.347-.009h2.735v.022" transform="translate(-249.978 -60.229)" fill="#2265fc"/>
                              <path id="Path_4278" data-name="Path 4278" d="M628.743,85.006c-.965,0-1.933.043-2.9-.009a3.587,3.587,0,0,1-3.32-2.931,3.247,3.247,0,0,1-.057-.576c0-1.267-.02-2.534,0-3.8a3.48,3.48,0,0,1,1.815-3.153,4.052,4.052,0,0,1,2.02-.513c1.684-.016,3.369-.035,5.052,0a3.511,3.511,0,0,1,3.173,1.873,3.728,3.728,0,0,1,.455,1.824c.006,1.275.023,2.55-.009,3.824A3.5,3.5,0,0,1,631.592,85c-.945.068-1.9.012-2.849.012v0m.007-2.593h0c.85,0,1.7,0,2.549,0a.9.9,0,0,0,1-.968c.006-1.305-.006-2.611,0-3.916a.824.824,0,0,0-.3-.627,1,1,0,0,0-.719-.266c-1.645,0-3.291-.026-4.936,0-.87.012-1.2.4-1.189,1.275q0,.6.009,1.205c.006.765-.012,1.53.024,2.294.034.716.363,1,1.085,1.007.826.006,1.653,0,2.48,0" transform="translate(-507.012 -60.278)" fill="#2265fc"/>
                              <path id="Path_4279" data-name="Path 4279" d="M702.866,63.913V63.45q0-5.885.007-11.771a3.559,3.559,0,0,1,3.1-3.52,7.6,7.6,0,0,1,1.291-.1c1.746-.01,3.491,0,5.237,0h.294v2.651c-2.045,0-4.06,0-6.075,0-.579,0-.961.214-1.091.667a1.75,1.75,0,0,0-.058.48q.007,5.828.021,11.656c0,.4,0,.4-.394.4-.764,0-1.527,0-2.333,0" transform="translate(-572.504 -39.143)" fill="#2265fc"/>
                              <path id="Path_4280" data-name="Path 4280" d="M766.72,57.5c0-1.916.021-3.832-.006-5.748a3.561,3.561,0,0,1,3.406-3.635c1.223-.087,2.455-.047,3.683-.057.865-.007,1.731,0,2.6,0,.191,0,.251.053.246.253q-.025,1.064-.009,2.128c0,.226-.069.287-.292.285-1.839-.01-3.677-.008-5.516-.007-.193,0-.386.007-.578.026a.925.925,0,0,0-.86.826,3.722,3.722,0,0,0-.036.508q0,5.157.009,10.314c0,.432.012.865.028,1.3.006.166-.04.233-.22.231-.757-.008-1.514-.006-2.271,0-.156,0-.194-.058-.194-.206q.006-3.105,0-6.211h.012" transform="translate(-624.503 -39.14)" fill="#2265fc"/>
                              <path id="Path_4281" data-name="Path 4281" d="M412.671,73.944h.568c.641,0,1.282.011,1.923,0,.188,0,.249.054.249.25q-.011,5.921-.009,11.842a3.551,3.551,0,0,1-3.539,3.724c-1.533.086-3.073.031-4.61.036-.571,0-.559,0-.55-.563.01-.625,0-1.251-.012-1.876,0-.17.039-.227.217-.227,1.483.006,2.966,0,4.449,0,.116,0,.232.007.347.016a.857.857,0,0,0,.97-.851c.009-.169,0-.34,0-.509q0-5.794,0-11.587Z" transform="translate(-331.26 -60.229)" fill="#2265fc"/>
                              <path id="Path_4282" data-name="Path 4282" d="M570.408,74.061c0,.444,0,.852,0,1.26,0,.379.006.757.021,1.135.007.165-.031.231-.216.23q-2.815-.018-5.631-.018a3.916,3.916,0,0,0-.553.039.915.915,0,0,0-.835.8,2.784,2.784,0,0,0-.033.484q0,3.453.013,6.905c0,.06-.011.119-.019.195h-2.05c-.629,0-.629,0-.629-.624q0-3.279,0-6.558a3.867,3.867,0,0,1,.442-1.941,3.707,3.707,0,0,1,3.005-1.858,9.542,9.542,0,0,1,1.11-.049c1.7,0,3.4,0,5.1,0h.276" transform="translate(-456.523 -60.325)" fill="#2265fc"/>
                              <path id="Path_4283" data-name="Path 4283" d="M385.931,74.055c.862,0,1.7,0,2.544,0,.16,0,.169.086.169.206,0,.571,0,1.143,0,1.715q0,2.642,0,5.283a1.965,1.965,0,0,0,.034.46.954.954,0,0,0,1.062.731q2.015-.025,4.03-.045c.285,0,.57,0,.881,0,.009.092.022.174.023.255,0,.726,0,1.452.009,2.177,0,.21-.066.26-.264.259-1.545-.008-3.09.014-4.634-.012a3.806,3.806,0,0,1-3.076-1.4,3.584,3.584,0,0,1-.784-2.256c-.019-2.417-.007-4.835-.007-7.253,0-.03.006-.059.012-.117" transform="translate(-314.339 -60.317)" fill="#2265fc"/>
                              <path id="Path_4284" data-name="Path 4284" d="M723.448,73.962h.326c1.847,0,3.693.006,5.54,0,.225,0,.306.051.3.3-.021.7-.015,1.406-.007,2.109,0,.192-.06.248-.254.247-1.87-.009-3.739-.008-5.609-.009-.3,0-.3,0-.3-.291q0-1.089-.006-2.179c0-.045,0-.09.007-.175" transform="translate(-589.263 -60.244)" fill="#2265fc"/>
                              <path id="Path_4285" data-name="Path 4285" d="M787.263,73.973h.285q2.756,0,5.511,0c.329,0,.32.005.317.339q-.009,1.029,0,2.058c0,.158-.027.239-.214.239q-2.837-.01-5.674-.006c-.119,0-.231.022-.23-.164.006-.809,0-1.618,0-2.469" transform="translate(-641.245 -60.253)" fill="#2265fc"/>
                            </g>
                          </svg>
                          <span>Godkendt af Finanstilsynet</span>
                        </div>
                        <div class="flex justify-start items-center cyprus">
                          <span>
                            <svg fill="currentColor" class="block" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"/></svg>
                          </span>
                          <p class="h5 line-height-1 m0 ml1 p0">Information</p>
                        </div>
                        <div class="py1"></div>
                        <div class="clearfix pr3 mb2">
                          <p class="line-height-4 mt1">For at sikre en tryg oplevelse i hele forløbet, har vi hos Håndværker.dk indgået et samarbejde med PayProff, om en deponeringskonto til opbevaring af din kundes penge, indtil projektet er fuldført.
                          </p>
                          <p class="line-height-4 mt1">PayProff er godkendt som betalingstjeneste hos Finanstilsynet. Du kan se deres licens  <a class="semi-bold" href="https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=30F336FD-6CE2-EC11-A2DB-005056907186" target="_blank">her</a>, og læse mere om de godkendelser, de har fået
                          </p>
                          <p class="line-height-4 mt1">
                          PayProff er en betalingsløsning skabt til at bringe sikkerhed ind i online pengehandel. Din kunde overfører entreprisesummen til kontoen, hvor de opbevares mens opgaven står på. Når opgaven er udført, kan du anmode om en udbetaling fra kunden, der via sin PayProff profil skal godkende udbetalingen.</p>
                          <p class="line-height-4 mt1">Det er med til at sikre dig, at der er en betaling klar, når projektet afsluttes.</p>
                        </div>
                        <div>
                          <el-collapse v-model="activeNames" accordion>
                            <el-collapse-item name="1">
                              <template slot="title">
                                <span class="h6 line-height-1 m0 p0 semi-bold py1">Hvorfor har du brug for mine bankoplysninger?</span>
                              </template>
                              <p class="line-height-golden">Vi har brug for dine bankoplysninger for at sende dig pengene eller for at
                                refundere dig, hvis det er nødvendigt. Det betyder også, at du ikke behøver
                                at dele dine bankoplysninger med din kontraktpartner.</p>
                            </el-collapse-item>
                            <el-collapse-item name="2">
                              <template slot="title">
                                <span class="h6 line-height-1 m0 p0 semi-bold py1">Hvordan overfører jeg pengene til PayProff?</span>
                              </template>
                              <p class="line-height-golden">De tilgængelige betalingsmetoder er: bankoverførsel, snart også i VISA,
                                Mastercard, Dankort og Mobilepay. Ved bankoverførsler får du alle de
                                bankoplysninger og referencenummer, du skal bruge input, når du foretager
                                overførslen. Bemærk venligst, at hvis du ikke indtaster det korrekte
                                referencenummer Der kan opstå forsinkelser, da vores system ikke vil være
                                i stand til at afstemme din betaling med det samme.</p>
                            </el-collapse-item>
                            <el-collapse-item name="3">
                              <template slot="title">
                                <span class="h6 line-height-1 m0 p0 semi-bold py1">Hvorfor bliver jeg stillet ekstra sikkerhedsspørgsmål?</span>
                              </template>
                              <p class="line-height-golden">For at overholde lovmæssige krav skal vi muligvis stille dig et par
                                ekstra spørgsmål. Dette er normal procedure for at sikre, at vi forstår,
                                hvordan du vil bruge vores tjenester, og det hjælper vi bekæmper
                                økonomisk kriminalitet.</p>
                            </el-collapse-item>
                            <el-collapse-item name="4">
                              <template slot="title">
                                <span class="h6 line-height-1 m0 p0 semi-bold py1">Hvorfor skal PayProff bekræfte min identitet? Hvad er Kend din kunde (KYC)?</span>
                              </template>
                              <p class="line-height-golden">PayProff er forpligtet til at levere et sikkert og sikkert miljø. Desuden har vi
                                en juridisk forpligtelse til ved, hvem vores kunder er. Det betyder, at hvis du
                                er privatperson, skal vi udføre en identitetsbekræftelse med NemID i Danmark.
                                Flere muligheder om identitetsbekræftelse både for private enkeltpersoner
                                og virksomheder i og uden for Danmark stilles til rådighed i 3. kvartal 2021.</p>
                            </el-collapse-item>
                          </el-collapse>
                        </div>
                      </div>
                    </tab-content>
                    <tab-content :before-change="validateCreatePayproffFirstTab">
                      <div class="flex flex-row mobile-flex-column">
                        <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                          <el-form-item label="Fornavn" prop="fornavn" class="border-none el-form-opgavetype  p0 mr-auto" >
                              <el-input v-model="payprofform.fornavn" :disabled="haspayproff || isexist" class=" white-background" placeholder="fornavn" clearable></el-input>
                          </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                          <el-form-item label="Efternavn" id="efternavn" prop="efternavn" class="border-none el-form-opgavetype  ml-auto">
                              <el-input v-model="payprofform.efternavn" :disabled="haspayproff || isexist" class=" white-background" placeholder="efternavn" clearable></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <!-- <el-alert type="error" effect="light" show-icon :closable="false" class="line-height-1 col-12 mx-auto"></el-alert> -->
                      <div class="flex flex-row mobile-flex-column">
                        <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                          <el-form-item label="Mellemnavn" prop="mellemnavn" class="border-none el-form-opgavetype  p0 mr-auto">
                              <el-input v-model="payprofform.mellemnavn" :disabled="haspayproff || isexist" class=" white-background" placeholder="mellemnavn" clearable></el-input>
                          </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6">
                          <el-form-item label="Fødelsdag" id="fodelsdag" prop="fodelsdag" class="border-none el-form-opgavetype  p0 ml-auto">
                              <datepicker id="datepickeroffer2" v-model="payprofform.fodelsdag" :disabled="haspayproff || isexist" class="col-12 m0 p0" :bootstrapStyling="false" placeholder="Fødelsdag" :language="da"></datepicker>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="flex flex-row mobile-flex-column">
                        <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                          <el-form-item label="Adresse" prop="Adresse" class="border-none el-form-opgavetype p0 mr-auto">
                              <el-input v-model="payprofform.Adresse" :disabled="haspayproff || isexist" class=" white-background" placeholder="Strandlodsvej 6, 1. sal" clearable></el-input>
                          </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                          <el-form-item label="zipcode" id="zipcode" prop="zipcode" class="border-none el-form-opgavetype p0 ml-auto">
                              <el-input v-model="payprofform.zipcode" :disabled="haspayproff || isexist" class=" white-background" placeholder="2300" clearable></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="flex flex-row mobile-flex-column">
                        <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                          <el-form-item label="By" prop="by" class="border-none el-form-opgavetype p0 mr-auto">
                              <el-input v-model="payprofform.by" :disabled="haspayproff || isexist" class=" white-background" placeholder="København s" clearable></el-input>
                          </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                          <el-form-item label="Stat" id="stat" prop="stat" class="border-none el-form-opgavetype p0 ml-auto">
                              <el-input v-model="payprofform.stat" :disabled="haspayproff || isexist" class=" white-background" placeholder="stat" clearable></el-input>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="flex flex-row mobile-flex-column">
                        <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                          <el-form-item label="Email" prop="email" class="border-none el-form-opgavetype p0 mr-auto">
                              <el-input v-model="payprofform.email" :disabled="haspayproff || isexist" class=" white-background" placeholder="E-mail" clearable></el-input>
                          </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                            <el-form-item label="Land" id="land" prop="land" class="border-none el-form-opgavetype p0 ml-auto">
                                <el-select class="white-background" v-model="payprofform.land" :disabled="haspayproff || isexist" filterable clearable placeholder="Country">
                                  <el-option v-for="(country, index) in countryData" :key="index" :label="country" :value="index">
                                  </el-option>
                                </el-select>
                            </el-form-item>
                          </div>
                      </div>
                      <div class="flex flex-row mobile-flex-column">
                          <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                            <el-form-item label="Telefonnummer" id="telefonnummer" prop="telefonnummer" class="border-none el-form-opgavetype p0 ml-auto">
                                <el-input v-model.number="payprofform.telefonnummer" :disabled="haspayproff || isexist" maxlength="8" class=" white-background"  placeholder="Tel.(8 cifre)" clearable></el-input>
                            </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                            <el-form-item label="Telefon contry code" id="telcountrycode" prop="telcountrycode" class="border-none el-form-opgavetype p0 ml-auto">
                                <el-input v-model.number="payprofform.telcountrycode" :disabled="haspayproff || isexist" class="white-background"  placeholder="+45" clearable></el-input>
                            </el-form-item>
                          </div>
                      </div>
                      <div class="flex flex-row mobile-flex-column">
                          <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                            <el-form-item label="CPR nummer" id="cprnummer" prop="cprnummer" class="border-none el-form-opgavetype p0 ml-auto">
                                <el-input v-model="payprofform.cprnummer" maxlength="10" :disabled="haspayproff || isexist" class=" white-background"  placeholder="XXXXXXXXXX" clearable></el-input>
                            </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                            <el-form-item label="Sprog" id="sprog" prop="sprog" class="border-none el-form-opgavetype p0 ml-auto">
                                <el-select class="white-background" v-model="payprofform.sprog" :disabled="haspayproff || isexist" filterable placeholder="sprog" clearable>
                                  <el-option v-for="(language, index) in languagesData" :key="index" :label="language" :value="index">
                                  </el-option>
                                </el-select>
                            </el-form-item>
                          </div>
                      </div>
                      <div class="flex flex-row mobile-flex-column">
                          <div class="m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                            <el-form-item label="Betalingsmiddel" id="currency" prop="currency" class="border-none el-form-opgavetype p0 ml-auto">
                                <el-select class="white-background" v-model="payprofform.currency" :disabled="haspayproff || isexist" filterable clearable placeholder="DKK">
                                  <el-option vlabel="DKK" value="DKK">
                                  </el-option>
                                  <!-- <el-option vlabel="EUR" value="EUR">
                                  </el-option> -->
                                </el-select>
                            </el-form-item>
                          </div>
                          <div class="m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12">
                            <el-form-item label="Iban" id="partneriban" prop="partneriban" class="border-none el-form-opgavetype p0 ml-auto">
                                <el-input v-model="partneriban" class=" white-background" maxlength="22"  placeholder="DKXXXXXXXXXXXXXXXXXX" clearable></el-input>
                            </el-form-item>
                            <label class="error red h5 small" v-if="ibanmessage">{{ibanmessage}}</label>
                          </div>
                      </div>
                    </tab-content>
                    <!-- <div class="flex ">
                      <button type="button" @click="clear()" class="mt2 not-rounded outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1"> <i class="el-icon-back pr1"></i>Afbryd
                      </button>
                      <button type="button" @click="openconfirmPayproff()" class=" mt2 not-rounded action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1">Næste <i class="pl1 el-icon-right"></i>
                      </button>
                    </div> -->
                    <template slot="footer" slot-scope="props">
                      <!-- Back and next -->
                      <div class="col-12 p0 flex mt2" :class="props.isLastStep ? 'justify-between' : 'justify-end'">
                        <button type="button" @click="props.prevTab()" class="outlined-primary-button h5 m0 line-height-4 regular px2 p1" v-if="props.activeTabIndex > 0">
                          <span class="ml1"><i class="el-icon-back"></i></span>
                          <span class="inline-block">Tilbage</span>
                        </button>
                        <button type="button" @click="props.isLastStep ? !haspayproff && !isexist ? openconfirmPayproff() : verifyIban('updateiban') : props.nextTab()" class="action-button h5 m0 line-height-4 regular px2 p1">
                          <span class="inline-block">{{props.isLastStep ? !haspayproff && !isexist ? 'Indsend' : 'Opdatering' : 'Næste'}}</span>
                          <span class="ml1"><i class="el-icon-right"></i></span>
                        </button>
                      </div>
                    </template>
                  </form-wizard>
                </el-form>
              </div>
            </div>
      </div>
    <b-modal  centered hide-footer v-model="confirmPayproff" id="confirmPayproff" :no-close-on-backdrop="true" ref="confirmPayproff" size="lg">
        <div class="col-12 flex justify-end items-center pt1 p0 mx-auto modal-header">
          <button class="ml-auto h4 p0 primary-white-button pointer close" @click="closeconfirmPayproff()">
            <i class="el-icon-circle-close"></i>
          </button>
        </div>
        <div class="clearfix white-background">
          <div class="flex flex-column items-start col-12 pb3 pt1 px3">
            <p class="muted-color h6 pt1" >Hvad er en politisk eksponeret person?</p>
            <p class="h6 semi-bold py1 mt1" >Politisk eksponerede personer (PEP'er) er personer, der bestrider et særligt offentligt tillidshverv og som følge af dette kan være modtagelige for bestikkelse og anden korruption.</p>
            <p class="h6 mt1 center">Er du en politisk udsat person? (PEP) ( Du ved, hvis du er )</p>
            <div class="col-12 flex justify-start my2">
              <template>
                <el-radio v-model="isPep" :label="true">Ja</el-radio>
                <el-radio v-model="isPep" :label="false">Nej</el-radio>
              </template>
            </div>
          </div>
        </div>
        <div class="flex ">
            <button type="button" @click="closeconfirmPayproff()" class=" mt2 not-rounded outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1"> <i class="el-icon-back pr1"></i>Tilbage
            </button>
            <button type="button" @click="verifyIban('')" class="mt2 not-rounded action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1">Godkend med MitID <i class="pl1 el-icon-right"></i>
            </button>
        </div>
    </b-modal>
    <div class="py4"></div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
	</div>
</template>
<script>
import datepicker from 'vuejs-datepicker'
import {en, da} from 'vuejs-datepicker/dist/locale'
import Simplert from 'vue2-simplert'
import countries from '../../components/countries.json'
import languages from '../../components/languages.json'
const Loading = () => import('@/components/Loading')
const ErrorHandler = () => import('@/components/ErrorHandler')
export default {
  name: 'payproff',
  components: {
    Simplert,
    ErrorHandler,
    en,
    da,
    datepicker,
    Loading
  },
  created () {
    this.partnerName = localStorage.getItem('name')
    this.haaid = localStorage.getItem('haaid')
    this.salesPerson = localStorage.getItem('id_token_portal_bitrix')
    this.dashdata = this.$route.query.dashdata
    this.getwalletinfo()
    this.supplierprofile()
  },
  data () {
    return {
      confirmPayproff: false,
      loading: false,
      salesPerson: '',
      haaid: '',
      partnerName: '',
      partneremail: '',
      partnerzip: '',
      partnertelephone: '',
      isPep: true,
      partnerprofile: [],
      payprofform: {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: 45,
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      },
      anbefalformrules: {
        fornavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit fornavn',
          trigger: 'blur'
        }],
        efternavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit efternavn',
          trigger: 'blur'
        }],
        fodelsdag: [{
          required: true,
          type: 'date',
          message: 'Du bedes indtaste dit fødelsdag',
          trigger: 'change'
        }],
        Adresse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit Adresse',
          trigger: 'blur'
        }],
        zipcode: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        by: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit by',
          trigger: 'blur'
        }],
        stat: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit stat',
          trigger: 'blur'
        }],
        land: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit gyldig land',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste en gyldig telnummer',
          trigger: 'blur'
        }],
        telcountrycode: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit code',
          trigger: 'blur'
        }],
        cprnummer: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste en cpr',
          trigger: 'blur'
        }]
      },
      countryData: countries,
      languagesData: languages,
      haspayproff: false,
      isexist: false,
      activeNames: [],
      isverified: false,
      verifylink: null,
      dashdata: '',
      partnerwalletid: '',
      partneriban: '',
      partnerwallet: {},
      ibanmessage: null
    }
  },
  mounted () {
  },
  methods: {
    closeconfirmPayproff () {
      this.confirmPayproff = false
    },
    validateCreatePayproffFirstTab () {
      return true
    },
    openconfirmPayproff () {
      var isnumber = /^\d+$/.test(this.payprofform.cprnummer)
      if (!isnumber) {
        this.$message({
          type: 'error',
          message: 'Indtast kun tal på cpr-nummeret'
        })
        return false
      }
      var error = 0
      this.$refs['payproffform'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1) { return }
      this.confirmPayproff = true
    },
    getwalletinfo () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/payproff/wallet', { headers }, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body.data
          this.partnerwallet = res
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    updateiban () {
      if (!this.partnerwallet) {
        this.$message({
          type: 'error',
          message: 'Din tegnebog er konfigureret korrekt, kontakt venligst support for yderligere hjælp'
        })
        return false
      }
      if (!this.partneriban) {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst dit Iban-nummer'
        })
        return false
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        iban: this.partneriban,
        walletid: this.partnerwallet['WALLET_ID']
      }
      this.$http.put(this.$bitrixapi + 'partner/payproff/wallet', data, { headers }, { emulateJSON: true }).then(
        (response) => {
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    verifyIban (ibantext) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'helper/validateIban/' + this.partneriban.replace(/ /g, ''), { headers }, data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.data.valid) {
            if (ibantext === 'updateiban') {
              this.updateiban()
            } else if (ibantext === '') {
              this.verify()
            }
            this.ibanmessage = null
          } else {
            var messagearr = ''
            res.data.messages.forEach(t => {
              messagearr += t + ', '
            })
            this.ibanmessage = messagearr
            this.$message({
              type: 'error',
              message: messagearr
            })
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    verify () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        email: this.payprofform.email,
        phoneNumber: this.payprofform.telefonnummer,
        phoneNumberAreaCode: this.payprofform.telcountrycode,
        firstName: this.payprofform.fornavn,
        middleName: this.payprofform.mellemnavn,
        lastName: this.payprofform.efternavn,
        address: this.payprofform.Adresse,
        zipCode: this.payprofform.zipcode,
        city: this.payprofform.by,
        state: this.payprofform.stat,
        country: this.payprofform.land,
        isPep: this.isPep,
        socialSecurityNumber: Number(this.payprofform.cprnummer),
        birthDate: this.payprofform.fodelsdag,
        displayLanguage: this.payprofform.sprog,
        currency: this.payprofform.currency,
        cvr: this.payprofform.cvr,
        companyName: this.payprofform.companyName,
        iban: this.partneriban.replace(/ /g, '')
      }
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/', data, { headers }, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.closeconfirmPayproff()
            // let obj = {
            //   title: 'Gennemført!',
            //   message: 'Success',
            //   type: 'success',
            //   customCloseBtnText: 'Luk'
            // }
            // this.$refs.simplert.openSimplert(obj)
            this.getNemIdUrlsubmit()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    getPayproffacc () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/exists/', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.isexist = res.data.exists
            this.haspayproff = res.data.payproff_verified
            this.verifylink = res.data.payproff_url
            if (!this.verifylink && !this.haspayproff && this.isexist) {
              this.getNemIdUrl()
            }
            if (this.haspayproff) {
              this.removeorangepayproffbanner()
            }
            this.loading = false
            if (this.$route.query.dashdata) {
              this.addbanner()
            }
          } else {
            this.loading = false
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        response => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    addbanner () {
      var checkpayproffbanner = document.getElementById('checkpayproffbanner')
      checkpayproffbanner.classList.remove('hide')
      var payproff = document.getElementById('payproff')
      payproff.style.marginTop = '52px'
    },
    addorangepayproffbanner () {
      var payproffnotification = document.getElementById('payproffnotification')
      payproffnotification.classList.remove('hide')
    },
    removeorangepayproffbanner  () {
      if (document.getElementById('payproffnotification')) {
        var payproffnotification = document.getElementById('payproffnotification')
        payproffnotification.classList.add('hide')
      }
    },
    getNemIdUrlsubmit () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body
          let closeFn = function () {
            this.$router.push('/alle-moeder')
          }
          let obj = {
            title: 'Gennemført!',
            message: 'Gå til den åbne fane i din browser for at bekræfte din betalingsprofil',
            type: 'success',
            onClose: closeFn,
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          this.closebanner()
          window.open(res.data.URL, '_blank').focus()
        },
        err => {
          this.$message({
            type: 'error',
            message: err.body.message
          })
        }
      )
    },
    closebanner () {
      var checkpayproffbanner = document.getElementById('checkpayproffbanner')
      checkpayproffbanner.classList.add('hide')
      this.addorangepayproffbanner()
    },
    updateStatus (buttonstatus) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      // clicked,submitted,verified
      var data = {
        status: buttonstatus
      }
      this.$http.post(this.$bitrixapi + 'partner/payproff/updateStatus', data, { headers }, { emulateJSON: true }).then(
        response => {
        },
        response => {
        })
    },
    updateStatusiban (ibannumber) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        iban: ibannumber
      }
      this.$http.post(this.$bitrixapi + 'partner/payproff/update', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          if (this.verifylink) {
            this.showlink(this.verifylink)
          } else if (res.PAYPROFFF_URL) {
            this.showlink(res.PAYPROFFF_URL)
          } else {
            this.getNemIdUrl()
          }
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getNemIdUrl () {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
      }
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body
          window.open(res.data.URL, '_blank').focus()
        },
        err => {
          this.$message({
            type: 'error',
            message: err.body.message
          })
        }
      )
    },
    showlink () {
      window.open(this.verifylink, '_blank').focus()
    },
    clear () {
      this.payprofform = {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: 45,
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      }
    },
    supplierprofile () {
      this.loading = true
      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaid, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            this.partnerprofile = res.data
            this.partnertelephone = res.data.MOBILE
            this.partneremail = res.data.EMAIL
            this.payprofform.telefonnummer = Number(res.data.UF_CRM_COMPANY_TELEPHONE)
            this.payprofform.email = res.data.EMAIL
            this.payprofform.by = res.data.UF_CRM_COMPANY_CITY
            this.payprofform.stat = res.data.UF_CRM_COMPANY_CITY
            this.payprofform.Adresse = res.data.UF_CRM_COMPANY_ADDRESS
            this.payprofform.zipcode = res.data.UF_CRM_COMPANY_ZIP_CODE
            this.payprofform.cvr = res.data.UF_CRM_COMPANY_CVR
            this.payprofform.companyName = res.data.TITLE
            // this.loading = false
            this.getPayproffacc()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        (response) => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    setmaskinput () {
      this.partneriban = this.$maskibanNumber(this.partneriban)
      // $('#partneriban').mask('(999) 999-9999? x9999', { autoclear: false })
    }
  },
  watch: {
    'partneriban': function (newVal, oldVal) {
      setTimeout(() => {
        if (newVal.length > 1) {
          this.setmaskinput(newVal)
        }
        if (newVal.length > 21) {
          this.verifyIban('checkiban')
        }
      }, 200)
    }
  }
}
</script>
<style>
#payproff .vue-form-wizard .wizard-nav-pills {
  display: none!important;
}
#checkpayproffbanner {
    margin-top: -54px;
    position: fixed;
    z-index: 100;
    padding-left: 10px;
    padding-right: 10px;
    /* border: 1px solid; */
    left: 320px;
    height: 35px;
    /* margin-left: auto; */
}
#payproffnotification {
    margin-top: 50px;
    position: fixed;
    z-index: 100;
    padding-left: 10px;
    padding-right: 10px;
    /* border: 1px solid; */
    /* margin-left: auto; */
}
#payproff .wizard-tab-content {
  padding: 0px;
}
#payproff .wizard-card-footer {
  padding: 0px;
}
#confirmPayproff___BV_modal_body_ .modal-header {
  display: block;
}
#confirmPayproff___BV_modal_body_ .close {
      color: #003645!important;
      background-color: #fff!important;
}
#confirmPayproff___BV_modal_body_ button.close  {
      padding: 0px!important;
}
#payproff .el-form-item__label {
  margin: 0px;
  padding: 0px;
  font-size: 17px;
  color: #003645;
}
#payproff .el-input__inner {
  font-size: 17px;
  color: #003645;
}
#payproff .el-input__inner {
  border-color: #003645;
  border-radius: 2px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 20px #00000005;
}
#payproff .el-select {
    width: 100%;
}
#payproff .vdp-datepicker input:focus {
  border: 0px!important;
}
#payproff .vdp-datepicker input{
    height: 40px;
    width: 100% ;
    border-radius: 2px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 20px #00000005;
    padding-left: 15px;
    border-width: 1px!important;
    border-color: #003645!important;
    border: 2px solid;
}
#payproff .wizard-header {
  display: none;
}
@media (max-width:27em) {
    .mmt4 {
      margin-top: 4rem;
    }
    #cvrfrom .mp0 {
      padding: 0!important;
    }
    .app-header {
      padding-left: .2rem;
      padding-right: .2rem;
    }
    .mm0 {
      margin: 0px;
    }
    .mmx-auto {
      margin-left: auto;
      -webkit-box-pack: center;
      justify-content: center;
    }
    .mmb5 {
      margin-bottom: 5rem;
    }
    .mpt1 {
      padding-top: .5rem;
    }
    .sm-hide {
      display: none;
    }
    .mobile-flex-column {
      flex-direction: column!important;
      align-items: center;
    }
    #checkpayproffbanner {
      margin-top: -54px;
      left: 0px;
    }
    #cvrfrom .el-form-item {
        margin-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// payproff.vue?5cae1c04